import React from 'react';
import { Modal } from 'react-bootstrap';

/**
 * VerifyIdentityModal
 *
 * Renders the "Verify Customer Identity" UI (see design).
 * Styling is done with Tailwind CSS; the outer modal shell uses react-bootstrap.
 */
const VerifyIdentityModal = ({
    show,
    closeModal,
    customer = {
        name: 'Aniket Verma',
        firmName: 'CP Firm Name',
        email: 'Vaibhav@8738gmail.com',
        phoneNumber: '9893803030'
    },
    channelPartner = {
        label: 'Channel Partner',
        name: 'Aman Gupa',
        firmName: 'Prpsmart Relaty',
        phoneNumber: 'Prpsmart Relaty'
    },
    onBack,
    onConfirm
}) => {
    const handleBack = () => {
        if (onBack) onBack();
        else if (closeModal) closeModal();
    };

    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        else if (closeModal) closeModal();
    };

    return (
        <Modal
            size="xl"
            show={show}
            onHide={closeModal}
            centered
            dialogClassName="!w-[640px] modal-radius import-modals"
        >
            <div className="bg-white rounded-2xl p-6 sm:p-8">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <h2 className="text-xl sm:text-2xl font-semibold text-[#344054]">
                        Verify Customer Identity
                    </h2>
                    <button
                        type="button"
                        onClick={closeModal}
                        className="ml-4 text-slate-400 hover:text-slate-600 text-2xl leading-none"
                    >
                        &times;
                    </button>
                </div>

                <div className="mt-6 space-y-4">
                    {/* Customer card */}
                    <div className="rounded-2xl border border-slate-200  !p-4 sm:px-6 sm:py-5">
                        <div className="flex items-start !gap-4 w-full">
                            <div className="w-full">
                                <div className='flex items-start !gap-4'>
                                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-200 text-slate-500">
                                        <span className="text-xl font-semibold">👤</span>
                                    </div>
                                    <div className="flex-1">
                                        <p className="text-base sm:text-lg font-semibold text-slate-900 mb-0">
                                            {customer.name}
                                        </p>
                                        <p className="text-sm text-slate-500 mb-0">
                                            {customer.firmName}
                                        </p>
                                    </div>
                                </div>

                                <div className="mt-4 grid !gap-4 sm:grid-cols-2 w-full">
                                    <div className="flex items-start gap-2">
                                        <span className="mt-0.5 text-[#344054] text-lg">
                                            ✉️
                                        </span>
                                        <div>
                                            <p className="text-xs font-medium uppercase tracking-wide text-grey-500 mb-0">
                                                Email
                                            </p>
                                            <p className="text-sm text-[#344054] mb-0">
                                                {customer.email}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                        <span className="mt-0.5 text-grey-500 text-lg">
                                            📞
                                        </span>
                                        <div>
                                            <p className="text-xs font-medium uppercase tracking-wide text-grey-500 mb-0">
                                                Phone Number
                                            </p>
                                            <p className="text-sm text-[#344054] mb-0">
                                                {customer.phoneNumber}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Channel Partner card */}
                    <div className="rounded-2xl border border-slate-200  !p-4 sm:px-6 sm:py-5 w-full">
                        <div className="flex items-start flex-col gap-4 w-full">
                            <div className="flex items-start !gap-4">

                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-200 text-slate-500">
                                    <span className="text-xl font-semibold">👤</span>
                                </div>
                                <p className="text-base sm:text-lg font-semibold text-[#344054]">
                                    {channelPartner.label}
                                </p>
                            </div>
                            <div className="flex-1 w-full">
                                <div className="mt-4 grid !gap-4 sm:grid-cols-2 w-full">
                                    <div className="flex items-start gap-2">
                                        <span className="mt-0.5 text-grey-500 text-lg">
                                            👤
                                        </span>
                                        <div>
                                            <p className="text-xs font-medium uppercase tracking-wide text-grey-500 mb-0">
                                                Name
                                            </p>
                                            <p className="text-sm text-[#344054] mb-0">
                                                {channelPartner.name}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-2">
                                        <span className="mt-0.5 text-grey-500 text-lg">
                                            🏢
                                        </span>
                                        <div>
                                            <p className="text-xs font-medium uppercase tracking-wide text-grey-500 mb-0">
                                                Phone Number
                                            </p>
                                            <p className="text-sm text-[#344054] mb-0">
                                                {channelPartner.phoneNumber || channelPartner.firmName}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer buttons */}
                <div className="mt-6 sm:mt-8 flex flex-col-reverse sm:flex-row sm:justify-between gap-3 w-full">
                    <button
                        type="button"
                        onClick={handleBack}
                        className="w-full sm:w-1/2 rounded-xl border border-slate-300 bg-white !px-4 !py-2.5 text-sm sm:text-base font-semibold text-slate-700 hover:bg-slate-50"
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className="w-full sm:w-1/2 rounded-xl bg-blue-600 !px-4 !py-2.5 text-sm sm:text-base font-semibold text-white shadow-sm hover:bg-blue-700"
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default VerifyIdentityModal;